<template>
	<div class="question-container" style="border: 1px solid #ededed">
		<div class="question-type">评星</div>

		<div class="title-view">
			<p style="color: #4c4a56">
				<span v-if="dataObj.isMust === 1" class="asterisk">*</span>
				{{ index + 1 }}、{{ dataObj.caseProblem }}
			</p>
		</div>

		<div class="question-images">
			<div v-for="(img, idx) in images" :key="idx" style="margin-top: 10px; position: relative">
				<img :src="img" style="width: 100%" />
			</div>
		</div>

		<div v-for="(item, idx) in list" :key="idx" class="evaluate-view">
			<div class="evaluate-view-score">
				<p class="sub-title">{{ item.text }}：</p>
			</div>

			<div class="evaluate-view-container">
				<img v-for="i in dataObj.scoreNum" :key="i" :src="getStarSrc(item.context, i)" class="stars_item" />
			</div>

			<div v-if="!ifElseConfig" class="rating">
				<div class="rating-item">
					<input type="text" placeholder="编辑提示词" v-model="item.ratingArr[0]" disabled />
				</div>
				<div class="rating-item">
					<input type="text" placeholder="编辑提示词" v-model="item.ratingArr[1]" disabled />
				</div>
				<div class="rating-item">
					<input type="text" placeholder="编辑提示词" v-model="item.ratingArr[2]" disabled />
				</div>
			</div>
		</div>

		<div v-if="ifElseConfig" class="rating">
			<div class="rating-item"><input type="text" v-model="value1" disabled /></div>
			<div class="rating-item"><input type="text" v-model="value2" disabled /></div>
			<div class="rating-item"><input type="text" v-model="value3" disabled /></div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			params: {
				type: Object,
				default: {}
			},
		},
		data() {
			return {
				dataObj: {},
				index: 0,
				list: [],
				images: [],
				starRatingStyle: 1,
				ifElseConfig: false,
				value1: "",
				value2: "",
				value3: "",
			};
		},
		methods: {
			getStarSrc(context, i) {
				const selected = i <= context ? "_2" : "_1";
				return require(`@/assets/images/questionnaire/${this.starRatingStyle}${selected}.svg`);
			},
		},
		watch: {
			params: {
				deep: true,
				immediate: true,
				handler(newVal) {
					if (!newVal.data) return;

					this.dataObj = newVal.data;
					this.index = newVal.index || 0;
					this.images = JSON.parse(newVal.data.caseProblemImg || "[]");
					this.list = JSON.parse(newVal.data.chooseList || '{"list":[]}').list;
					this.starRatingStyle = newVal.data.starRatingStyle || 1;

					if (newVal.answer && Array.isArray(newVal.answer.answer)) {
						const answers = newVal.answer.answer;
						this.list.forEach((item) => {
							const matched = answers.find((ans) => ans.id === item.id);
							item.context = matched ? Number(matched.context) : 0;
						});
					} else {
						this.list.forEach((item) => (item.context = 0));
					}

					if (newVal.data.elseConfig) {
						this.ifElseConfig = true;
						const elseArr = JSON.parse(newVal.data.elseConfig);
						this.value1 = elseArr[0];
						this.value2 = elseArr[1];
						this.value3 = elseArr[2];
					}
				},
			},
		},
	};
</script>

<style scoped>
	.score-view {
		margin-top: 15px;
		display: flex;
		justify-content: space-between;
	}

	.score-view-item-active {
		width: 29px;
		height: 30px;
		line-height: 30px;
		background-color: #4a73f8;
		color: #ffffff;
		font-size: 14px;
		font-weight: 600;
		text-align: center;
	}

	.score-view-item-inactive {
		width: 27px;
		height: 27px;
		line-height: 27px;
		border: 1px solid #ededed;
		background-color: #f9f9f9;
		color: #2b2f36;
		font-size: 14px;
		font-weight: 400;
		text-align: center;
	}

	.evaluate-view {
		width: 100%;
		padding: 25px;
		box-sizing: border-box;
		background-color: #f9f9f9;
		border-radius: 3px;
		margin-top: 25px;
	}

	.evaluate-view-score {
		width: 100%;
		text-align: left;
	}

	.evaluate-view-container {
		display: flex;
		justify-content: space-between;
		margin-top: 10px;
		gap: 10px;
	}

	.evaluate-item {
		width: 25px;
		height: 25px;
		line-height: 25px;
		border-radius: 25px;
		text-align: center;
		font-size: 14px;
		font-weight: 600;
		border: 1px solid #ededed;
	}

	.rating {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 10px;
	}

	.rating-item {
		width: 170px;
		height: 33px;
		background: #ffffff;
		border: 1px solid #ededed;
		border-radius: 3px;
		display: flex;
		align-items: center;
		padding: 0 13px;
		box-sizing: border-box;
	}

	.rating-item input {
		width: 100%;
		height: 100%;
		border: none;
		box-sizing: border-box;
		font-size: 13px;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewSRQ.vue